<ng-container *ngIf="history$ | async as history">
  <prlw-license-history-ui [history]="history"></prlw-license-history-ui>
</ng-container>
